export default class DownloadMarcForm {
    /**
     * @param form
     * @type HTMLFormElement
     */
    _format = undefined;
    _type = undefined;
    _recipient = undefined;

    constructor(form) {
        this.form = form;
        this.init();
    }

    init() {
        /**
         * always include the report type param
         * report param expected values are "all_journals" or "subscribed_journals" or "all_books" or "subscribed_books" or "isbn_list"
         * isbn list textarea is only expected to be displayed when choosing isbn_list report type
         *
         * always include the format param
         * format param expected values are "xml" or "mrc"
         *
         * always include the redirect uri param
         *
         * always include the email param
         * 'blah@example.com' or 'blah@example.com,blah2@example.com', in case the email(s) is provided by the user
         * 'all_institutional_admins', if the option to send to all admins is chosen
         *
         * include the inst param when choosing to email the report to all_institutional_admins
         * include the inst param when choosing subscribed_journals and subscribed_books report type
         *
         * dates params (start-date, end-date) format should always be in the 'yyyy-MM-dd'
         * dates fields are only expected to be displayed when choosing all_books and subscribed_books report type
         *
         */

        this.reportFields();
        this.formatFields();
        this.recipientFields();
        this.formSubmit();
    }

    _convertToArray(nodeList) {
        return nodeList ? Array.prototype.slice.call(nodeList) : [];
    }

    reportFields() {
        const typeRadioButtons = this._convertToArray(this.form.report);
        typeRadioButtons.forEach(btn => btn.addEventListener('change', this._handleTypeRadioChange.bind(this)));
    }
    _handleTypeRadioChange(event) {
        const typeLabel = {
            allJournals: 'all Journals',
            allBooks: 'all Books',
            allSubscribedJournals: 'all Subscribed Journals',
            allPurchasedBooks: 'all Purchased Books',
            allReferenceWorks: 'all Reference Works',
            purchasedReferenceWorks: 'purchased Reference Works',
            isbn_list: 'ISBN List',
        };
        this._type = typeLabel[event.currentTarget.id];

        this._handleISBNTextarea(event.currentTarget);
        this._handleDateRange(event.currentTarget);
    }
    _handleISBNTextarea(target) {
        const {isbn_list, isbn, report_isbnList} = this.form;
        if (report_isbnList) {
            if (isbn_list === target) {
                report_isbnList.classList.remove('hidden');
                isbn.disabled = false;
                isbn.focus();
            } else {
                report_isbnList.classList.add('hidden');
                isbn.disabled = true;
            }
        }
    }
    _handleDateRange(target) {
        const {
            allBooks,
            allPurchasedBooks,
            allReferenceWorks,
            purchasedReferenceWorks,
            report_period,
            'start-date': startDate,
            'end-date': endDate,
        } = this.form;
        if (report_period) {
            if (
                allBooks === target ||
                allPurchasedBooks === target ||
                allReferenceWorks === target ||
                purchasedReferenceWorks === target
            ) {
                report_period.classList.remove('hidden');
                startDate.disabled = false;
                endDate.disabled = false;
            } else {
                report_period.classList.add('hidden');
                startDate.disabled = true;
                endDate.disabled = true;
            }
        }
    }

    formatFields() {
        const formatRadioButtons = this._convertToArray(this.form.format);
        formatRadioButtons.forEach(btn => btn.addEventListener('change', this._handleFormatRadioChange.bind(this)));
    }
    _handleFormatRadioChange(event) {
        const typeLabel = {
            marc: 'MARC',
            xml: 'XML',
        };
        this._format = typeLabel[event.currentTarget.id];
    }
    recipientFields() {
        const emailRadioButtons = this._convertToArray(this.form.recipient);
        emailRadioButtons.forEach(btn => btn.addEventListener('change', this._handleEmailRadioChange.bind(this)));

        const recipientUpdateValue = event => {
            const {userInput, userEmail, email} = this.form;
            if (userInput.checked) {
                email.value = userEmail.value;
            }
            this._recipient = event.target.value;
        };
        this.form.userEmail.addEventListener('keyup', recipientUpdateValue);
    }
    _handleEmailFields(target) {
        const {userInput, email, userEmail} = this.form;
        if (userInput === target) {
            userEmail.disabled = false;
            userEmail.focus();
            email.value = userEmail.value;
        } else {
            userEmail.disabled = true;
            email.value = target.value;
        }
    }
    _handleEmailRadioChange(event) {
        const typeLabel = {
            userInput: this.form.userEmail.value,
            allAdmins: 'all Administrators',
        };
        this._recipient = typeLabel[event.currentTarget.id];

        this._handleEmailFields(event.currentTarget);
    }

    formSubmit() {
        this.form.addEventListener('submit', this._handleSubmit.bind(this));
    }
    _handleSubmit() {
        const {isbn, recipient, userEmail} = this.form;
        isbn.value = isbn.value.replace(/\r\n/g, '\n').split('\n').toString();
        recipient[0].disabled = 'disabled';
        recipient[1].disabled = 'disabled';
        userEmail.disabled = 'disabled';
    }
}
